export default "__VITE_ASSET__BaObo2IR__"